// W3C trace context on backend calls (docs/otel-tracing-plan.md, browser "option 1"): every API request carries a
// traceparent header, and the requests one user action fires together (a simulation run and its pills, a board scan)
// share a trace ID, so the backend's spans for that action land in one trace in Cloud Trace. The browser exports no
// spans of its own; the header's parent span ID just stands for the user's action.

// Random bytes for IDs (unique, not secret: Math.random is a fine fallback where crypto isn't available).
const randomBytes = (n: number): Uint8Array => {
  const a = new Uint8Array(n);
  if (typeof crypto !== 'undefined' && typeof crypto.getRandomValues === 'function') crypto.getRandomValues(a);
  else for (let i = 0; i < n; i++) a[i] = Math.floor(Math.random() * 256);
  return a;
};

const hex = (bytes: number): string => Array.from(randomBytes(bytes), (b) => b.toString(16).padStart(2, '0')).join('');

let action: { traceId: string; until: number } | null = null;

/** Starts a user action: requests sent in the next moment (by default 2 seconds) share one trace. */
export const startTraceAction = (ms = 2000): void => {
  action = { traceId: hex(16), until: Date.now() + ms };
};

/** A traceparent header value: the current action's trace, or a new one. */
export const traceparent = (): string => {
  const traceId = action && Date.now() < action.until ? action.traceId : hex(16);
  return `00-${traceId}-${hex(8)}-01`;
};
